import React, { Component } from 'react';
import { Panel, Button, Media, Image, Col } from 'react-bootstrap';
import "./Start.css";
import Referer from './Start/Referer';

import GCPSmall from "./GCP_small.png"
import Me from "./johnny.jpg";
import Håkan from "./hakan.jpg";
import Gustav from "./gustav.jpg";
import Staffan from "./staffan.jpg";

class Start extends Component {
  render() {
    const contact = atob("aW5mb0Bqb29uaXguc2U=");
    return (
      <div>
        <Col xs={12} smOffset={1} sm={10}>
          <Panel>
            <Media>
              <Media.Body>
                  <h3>Hej! Behöver ni hjälp med IT-utveckling på molnet?</h3>
                  <p>
                      Är ni ett mindre eller medelstort företag som
                      behöver hjälp med utveckling och planering av er platform?
                      Jag finns tillgänglig som fristående konsult och kan realisera
                      era projekt med tillsvidare underhåll
                      och stöd av lösningen i sin helhet.
                  </p>
              </Media.Body>
              <Media.Right align="middle" >
                <Col xsHidden><Image src={Me} circle role="presentation" /></Col>
              </Media.Right>
            </Media>
            <Col smHidden mdHidden lgHidden><Image className="center-block" src={Me} circle role="presentation" /></Col>
            <h4>Om mig</h4>
            <p>
                Joonix är baserat i Göteborg och drivs av mig, Johnny Bergström.
                Jag har många års erfarenhet av arbete med att planera och bygga
                molnanpassade tjänster på Google Cloud Platform & Amazon Web Services.
            </p>
            <Button bsSize="large" bsStyle="primary" href={"mailto:" + contact}>Kontakta mig</Button>
          </Panel>
          <Panel>
            <Media>
              <Media.Left align="middle">
                <Col xsHidden><Image className="GCPSmall" src={GCPSmall} /></Col>
              </Media.Left>
              <Media.Body>
                <Media.Heading>
                  <Col smHidden mdHidden lgHidden><Image className="GCPSmall center-block" src={GCPSmall} /></Col>
                  Google Cloud Partner
                </Media.Heading>
                <p>
                  Joonix är en registrerad Google Cloud Partner och har certifierad expertis inom denna platform.
                  Som förmån till nya kunder kan vi även erbjuda USD $500 i kredit på alla tillgängliga tjänster hos <a href="https://goo.gl/esPL6n">Google Cloud Platform</a>. Ta gärna kontakt för mer information.
                </p>
              </Media.Body>
            </Media>
          </Panel>
          <Panel>
            <Referer image={Håkan}>
              <p>
                Som Backend Lead i systerbolaget Duego Technologies AB, hade Johnny ansvaret för att bygga infrastrukturen som serverar all trafik till slutanvändaren. Uppgiften att skapa en platform för att hantera tusentals förfrågningar per sekund och att vara stöd för övriga utvecklare i deras dagliga arbete har genomförts på ett effektivt och genomtänkt sätt. Jag har aldrig känt mig orolig över att något inte ska bli löst när ansvaret tilldelats Johnny. Han rekommenderas starkt!
              </p>
              <footer>
                <span>Håkan Malm</span>
                <p>COO, Saltside Technologies AB</p>
              </footer>
            </Referer>
            <Referer image={Gustav}>
              <p>
                Mobajl är sedan 2005 aktiva inom digital- och mobilmarknadsföring. Under sin tid hos oss ansvarade Johnny för den tekniska utvecklingen i bolaget samt uppbyggnaden av bolagets digitala kampanjer på nätet. Johnny har med stor kompetens utfört de uppgifter som vi efterfrågat och han har också visat prov på effektivitet och snabbhet i arbetet. Johnny är en tillgång för varje företag som vill ta del av hans kreativitet och vi kan därför varmt rekommendera honom till liknande uppdrag.
              </p>
              <footer>
                <span>Gustav Perers</span>
                <p>VD, Mobajl AB</p>
              </footer>
            </Referer>
            <Referer image={Staffan}>
              <p>
                Johnny är en otroligt talangfull och diciplinerad utvecklare. Allt han skapar håller en väldigt hög kvalité och ett djupgående säkerhetstänk är en självklarhet. En av hans bästa egenskaper är hans ständiga törst efter ny kunskap. Med Johnny i teamet kommer man alltid ligga i den absoluta framkanten av den tekniska utvecklingen. Jag ser personligen fram mot den dagen då jag får nöjet att jobba tillsammans med honom igen!
              </p>
              <footer>
                <span>Staffan Sundblad</span>
                <p>VD, Machinima Entertainment Sweden AB</p>
              </footer>
            </Referer>
          </Panel>
        </Col>
      </div>
    )
  }
}

export default Start;


/** WEBPACK FOOTER **
 ** ./src/Start.js
 **/